import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import api from "../../apiSetup/apiCall";
import { toast } from 'react-toastify';
import CloseIcon from "@mui/icons-material/Close";
import { compressImage } from "../../common";
import UploadIcon from "../../assets/stationManagement/Upload.svg";
import { Box, Dialog } from "@mui/material";

const CustomSingleFileUpload = ({
    label,
    required,
    col_size,
    is_error,
    value: propValue,
    api: url,
    disabled,
    onValueChange,
    helper_text
}) => {
    const [value, setValue] = useState("");
    const [alert, setAlert] = useState(false);

    useEffect(() => {
        setValue(propValue ? propValue : "")
    }, [propValue])

    const handleUpload = async (event) => {
        const file = event.target.files[0];
        let quality = 0.7;
        let compressedImage = file;
        if (file) {
            do {
                compressedImage = await compressImage(compressedImage, quality);
                quality -= 0.1;

            } while ((compressedImage.size / 1024) > 700);
            try {
                const formData = new FormData();
                formData.append('file', compressedImage);
                const response = await api.post(url.upload, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                });

                onValueChange(response?.data?.data);
            } catch (error) {
                toast.error('Error Uploading File. Please retry!');
            }
        }
    };

    const removeUpload = async (event) => {
        try {
            const response = await api.put(url.delete, { url: value })
            onValueChange("");
            setAlert(false);
        }
        catch (error) {
            toast.error('Error Removing File . Please retry !')
        }
    }


    return (
        <Grid item xs={12} marginBlock={2}>
            <Grid container flexDirection="row">
                <Grid item xs={4.5} marginRight="15px">
                    <Grid container flexDirection="column">
                        <Typography style={{ fontSize: "14px", fontWeight: "600", lineHeight: "18px" }}>
                            {label}
                            {required && <span style={{ color: "red", marginLeft: "5px" }}>*</span>}
                        </Typography>
                        {
                            helper_text &&
                            <Typography style={{ fontSize: "11px", fontWeight: "400", lineHeight: "15px", color: "grey", marginTop: "4px" }}>
                                {helper_text}
                            </Typography>

                        }
                    </Grid>
                </Grid>
                {
                    value?.length > 0 &&
                    <Grid item xs={7}>
                        <Grid container style={{ marginTop: "16px", gap: '10px' }} >
                            <Grid item position='relative' sx={{ border: '1px solid rgba(0,0,0,0.5)', borderRadius: '10px', width: '50px', height: '50px' }}>
                                <img src={value} alt='profile_pic' style={{ borderRadius: '10px', width: '100%', height: '100%' }} />
                                <IconButton
                                    // onClick={(e) => removeUpload(e, value)}
                                    onClick={(e) => setAlert(true)}
                                    sx={{
                                        position: "absolute",
                                        top: "-6px",
                                        right: "-6px",
                                        color: "red",
                                        padding: 0,
                                        backgroundColor: 'white'
                                    }}
                                >
                                    <CloseIcon sx={{ fontSize: "17px" }} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {
                    value?.length <= 0 &&
                    <Grid item xs={7}>
                        <Grid container component="label" htmlFor="file_label" sx={{ border: "1px solid #E4E7EC", paddingBlock: "11px", borderRadius: "10px", cursor: "pointer" }} alignItems="center" flexDirection="column">
                            <img src={UploadIcon} width="30px" height="30px" alt="upload_icon" />
                            <Grid container justifyContent="center" sx={{marginTop: "10px"}}>
                                <Typography color="#467CEB" fontWeight="600">
                                    Click to upload
                                </Typography>
                                <Typography sx={{ marginLeft: "2px" }}>
                                    or drag and drop
                                </Typography>
                            </Grid>
                            <Typography fontSize="12px">
                                image file (max. 256 kb)
                            </Typography>
                        </Grid>
                        <input
                            type="file"
                            id="file_label"
                            style={{ display: "none" }}
                            onChange={handleUpload}
                            disabled={disabled}
                            accept=".jpg, .jpeg, .png"
                        />
                    </Grid>}
            </Grid>
            <Dialog onClose={(e) => setAlert(false)} open={alert}>
                <Grid container alignItems="center" flexDirection={"column"} padding="20px" maxWidth="380px">
                    <Typography variant="h6" marginBottom="20px" textAlign="center">
                        Are you sure want to remove this station icon?
                    </Typography>
                    <Button onClick={(e) => removeUpload(e)} variant="contained" sx={{display: "block", width: "100%", borderRadius: "20px", padding: "8px", fontWeight: "600", marginBottom: "5px"}}>
                        Yes
                    </Button>
                    <Button onClick={(e) => setAlert(false)} variant="text" sx={{display: "block", width: "100%", padding: "8px", fontWeight: "600", }}>
                        Cancel
                    </Button>
                </Grid>
            </Dialog>
        </Grid>
    );
};

export default CustomSingleFileUpload;
